<div class="cookie-consent-overlay" *ngIf="showBanner">
    <div class="cookie-consent-box">
      <div class="cookie-header">
        <h5>🍪 Gestion des cookies</h5>
        <button class="close-btn" (click)="close()" aria-label="Fermer">
          <span class="close-icon">×</span>
        </button>
      </div>
      <p class="cookie-text">
        Nous utilisons des cookies pour assurer le bon fonctionnement du site 
        et améliorer votre expérience. 
        Gérez vos préférences à tout moment.
      </p>
  
      <div class="cookie-actions">
        <button class="btn btn-accept" (click)="accept()">Accepter</button>
        <button class="btn btn-refuse" (click)="refuse()">Refuser</button>
        <button class="btn btn-preferences" (click)="togglePreferences()">
          Voir préférences
        </button>
      </div>
  
      <div class="cookie-preferences" *ngIf="showPreferences">
        <h6>Vos préférences</h6>
        <div class="preferences-list">
          <div class="preference">
            <label class="checkbox-label">
              <input type="checkbox" [(ngModel)]="prefs.necessary" disabled />
              <span class="checkmark"></span>
              <span class="label-text">Cookies nécessaires (toujours activés)</span>
            </label>
          </div>
          <div class="preference">
            <label class="checkbox-label">
              <input type="checkbox" [(ngModel)]="prefs.analytics" />
              <span class="checkmark"></span>
              <span class="label-text">Cookies analytiques</span>
            </label>
          </div>
          <div class="preference">
            <label class="checkbox-label">
              <input type="checkbox" [(ngModel)]="prefs.marketing" />
              <span class="checkmark"></span>
              <span class="label-text">Cookies marketing</span>
            </label>
          </div>
        </div>
        <button class="btn btn-save" (click)="savePreferences()">Sauvegarder</button>
      </div>
    </div>
  </div>